export const lang = [
    {
        lang : "Tamil" ,
        flag : "india" 
    },
    {
        lang : "English",
        flag : "uk"
    },
    {
        lang : "Hindi" ,
        flag : "india"
    },
    {
        lang : "Urdu" ,
        flag : "india"
    },
    {
        lang : "Japanese",
        flag : "japan"
    }
]